// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings {
  width: 100vw;
  max-width: 430px; /* iPhone 12 Pro Max width, adjust as needed */
  margin: 0 auto; /* Center the settings container */
  height: 100vh; /* Full height */
  background-color: #fff; /* White background like iOS */
  overflow-y: auto; /* Enable scrolling if content is longer than the screen */
  overflow-x: hidden; /*stop horizontal scroll */
  border-radius: 40px; /* Rounded corners like iOS */
 /*  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); Slight shadow for depth */
}

/* Rest of your CSS */


.switch {
position: relative;
display: inline-block;
width: 60px;
height: 34px;
/* Add more styles to match the screenshot */
}

.switch input {
opacity: 0;
width: 0;
height: 0;
}



input:checked + .slider {
background-color: #2196F3;
}

input:focus + .slider {
box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
border-radius: 34px;
}

.slider.round:before {
border-radius: 50%;
}

.settings-header {
  background: #f2f2f7;
  padding: 10px;
}

.settings-header input {
  width: 97%;
  background-color: #e1e1e1;
  padding: 8px;
  border: none;
  border-radius: 10px;
}

.settings-profile {
  display: flex;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #c7c7cc;
}

.settings-profile img {
  border-radius: 50%;
  margin-right: 10px;
  max-width: 65px;
  width: 100%;
  max-height: 65px;
}

.settings-options {
  display: flex;
  flex-direction: column;
  align-items: center;
justify-content: space-between;
}

.divider {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 2em;
  background-color: #e1e1e1;
}


/* Add your existing styles here */

/* Icon classes with background colors */
.icon-settings {
display: inline-block;
width: 30px;
height: 30px;
border-radius: 50%;
color: white;
text-align: center;
line-height: 30px;
font-size: 16px;
}

.logout-button{
padding: 5px;
color: #0A84FF;
border-radius: 1em;
width: 25%;
font-weight: 800;
font-size: large;
}

.icon-airplane {
background-color: #0A84FF; /* Replace with actual color */
}

.icon-wifi {
background-color: #5856D6; /* Replace with actual color */
}

.icon-bluetooth {
background-color: #5AC8FA; /* Replace with actual color */
}

.icon-cellular {
background-color: #FF2D55; /* Replace with actual color */
}

.icon-hotspot {
background-color: #FF9500; /* Replace */
}

.settings-option {
  display: flex;
  align-items: center;
  width: 90%;
  justify-content: space-between;
  padding: 10px 20px;
  border-bottom: 1px solid #c7c7cc;
}


.name {
  flex-grow: 1;
  padding-left: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}



.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  transform: translateX(16px);
}
`, "",{"version":3,"sources":["webpack://./src/components/css/SettingsScreen.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB,EAAE,8CAA8C;EAChE,cAAc,EAAE,kCAAkC;EAClD,aAAa,EAAE,gBAAgB;EAC/B,sBAAsB,EAAE,8BAA8B;EACtD,gBAAgB,EAAE,0DAA0D;EAC5E,kBAAkB,EAAE,0BAA0B;EAC9C,mBAAmB,EAAE,6BAA6B;CACnD,sEAAsE;AACvE;;AAEA,qBAAqB;;;AAGrB;AACA,kBAAkB;AAClB,qBAAqB;AACrB,WAAW;AACX,YAAY;AACZ,4CAA4C;AAC5C;;AAEA;AACA,UAAU;AACV,QAAQ;AACR,SAAS;AACT;;;;AAIA;AACA,yBAAyB;AACzB;;AAEA;AACA,2BAA2B;AAC3B;;AAEA;AACA,2BAA2B;AAC3B;;AAEA,oBAAoB;AACpB;AACA,mBAAmB;AACnB;;AAEA;AACA,kBAAkB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB,8BAA8B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;;AAGA,kCAAkC;;AAElC,wCAAwC;AACxC;AACA,qBAAqB;AACrB,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB,eAAe;AACf;;AAEA;AACA,YAAY;AACZ,cAAc;AACd,kBAAkB;AAClB,UAAU;AACV,gBAAgB;AAChB,gBAAgB;AAChB;;AAEA;AACA,yBAAyB,EAAE,8BAA8B;AACzD;;AAEA;AACA,yBAAyB,EAAE,8BAA8B;AACzD;;AAEA;AACA,yBAAyB,EAAE,8BAA8B;AACzD;;AAEA;AACA,yBAAyB,EAAE,8BAA8B;AACzD;;AAEA;AACA,yBAAyB,EAAE,YAAY;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;;AAGA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;;;AAIA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B","sourcesContent":[".settings {\n  width: 100vw;\n  max-width: 430px; /* iPhone 12 Pro Max width, adjust as needed */\n  margin: 0 auto; /* Center the settings container */\n  height: 100vh; /* Full height */\n  background-color: #fff; /* White background like iOS */\n  overflow-y: auto; /* Enable scrolling if content is longer than the screen */\n  overflow-x: hidden; /*stop horizontal scroll */\n  border-radius: 40px; /* Rounded corners like iOS */\n /*  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); Slight shadow for depth */\n}\n\n/* Rest of your CSS */\n\n\n.switch {\nposition: relative;\ndisplay: inline-block;\nwidth: 60px;\nheight: 34px;\n/* Add more styles to match the screenshot */\n}\n\n.switch input {\nopacity: 0;\nwidth: 0;\nheight: 0;\n}\n\n\n\ninput:checked + .slider {\nbackground-color: #2196F3;\n}\n\ninput:focus + .slider {\nbox-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked + .slider:before {\ntransform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\nborder-radius: 34px;\n}\n\n.slider.round:before {\nborder-radius: 50%;\n}\n\n.settings-header {\n  background: #f2f2f7;\n  padding: 10px;\n}\n\n.settings-header input {\n  width: 97%;\n  background-color: #e1e1e1;\n  padding: 8px;\n  border: none;\n  border-radius: 10px;\n}\n\n.settings-profile {\n  display: flex;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #c7c7cc;\n}\n\n.settings-profile img {\n  border-radius: 50%;\n  margin-right: 10px;\n  max-width: 65px;\n  width: 100%;\n  max-height: 65px;\n}\n\n.settings-options {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\njustify-content: space-between;\n}\n\n.divider {\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  height: 2em;\n  background-color: #e1e1e1;\n}\n\n\n/* Add your existing styles here */\n\n/* Icon classes with background colors */\n.icon-settings {\ndisplay: inline-block;\nwidth: 30px;\nheight: 30px;\nborder-radius: 50%;\ncolor: white;\ntext-align: center;\nline-height: 30px;\nfont-size: 16px;\n}\n\n.logout-button{\npadding: 5px;\ncolor: #0A84FF;\nborder-radius: 1em;\nwidth: 25%;\nfont-weight: 800;\nfont-size: large;\n}\n\n.icon-airplane {\nbackground-color: #0A84FF; /* Replace with actual color */\n}\n\n.icon-wifi {\nbackground-color: #5856D6; /* Replace with actual color */\n}\n\n.icon-bluetooth {\nbackground-color: #5AC8FA; /* Replace with actual color */\n}\n\n.icon-cellular {\nbackground-color: #FF2D55; /* Replace with actual color */\n}\n\n.icon-hotspot {\nbackground-color: #FF9500; /* Replace */\n}\n\n.settings-option {\n  display: flex;\n  align-items: center;\n  width: 90%;\n  justify-content: space-between;\n  padding: 10px 20px;\n  border-bottom: 1px solid #c7c7cc;\n}\n\n\n.name {\n  flex-grow: 1;\n  padding-left: 10px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n}\n\n\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: #2196F3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
